import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import EmergencyButton from './EmergencyButton';

const AXIOM_LOGO = 'https://customer-assets.emergentagent.com/job_sponsor-bot-clinical/artifacts/kgiafx8p_AxiomLogo.png';

function PageHeader({ title, backTo, showHome = true, parentSection = null }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-zinc-200 z-40 shadow-sm">
      {/* Parent Section Link */}
      {parentSection && (
        <div className="bg-zinc-50 border-b border-zinc-200 px-4 py-1.5">
          <button
            onClick={() => navigate(parentSection.route)}
            className="flex items-center gap-1.5 text-xs text-zinc-600 hover:text-zinc-900 transition-colors"
            data-testid="parent-section-link"
          >
            <ArrowLeft className="w-3 h-3" />
            <span className="font-medium">{parentSection.label}</span>
          </button>
        </div>
      )}
      
      {/* Main Header */}
      <div className="h-14 px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button 
            onClick={handleBack} 
            className="p-1.5 rounded-md hover:bg-zinc-100 transition-colors"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5 text-zinc-700" />
          </button>
          
          {showHome && (
            <button 
              onClick={() => navigate('/dashboard')} 
              className="p-1.5 rounded-md hover:bg-zinc-100 transition-colors"
              data-testid="home-button"
            >
              <Home className="w-5 h-5 text-zinc-500" />
            </button>
          )}
        </div>
        
        {title ? (
          <h1 className="text-base font-semibold text-zinc-950 absolute left-1/2 transform -translate-x-1/2">
            {title}
          </h1>
        ) : (
          <img src={AXIOM_LOGO} alt="Axiom" className="h-7 absolute left-1/2 transform -translate-x-1/2" />
        )}
        
        <EmergencyButton />
      </div>
    </header>
  );
}

export default PageHeader;
